<template>
  <div class="">
    <hr>
    <div class="my-2">
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">شناسه: {{ item.id }}</span>
      <div class="form-group d-inline-block">
        <input :id="`secure-${item.id}`" type="checkbox" v-model="item.security">
        <label :for="`secure-${item.id}`" class="mx-2 d-inline-block">محافظت شده</label>
      </div>
    </div>
    <div class="form-group">
      <input type="text" class="mb-2 form-control" v-model="item.title">

      <div class="d-flex align-items-center my-2">
        <b-icon
          v-for="score in maxScore"
          :key="score"
          :icon="score <= displayedScore ? 'star-fill' : 'star'"
          class="star-icon mx-1"
          :class="{ 'star-active': score <= displayedScore }"
          @mouseover="hoverScore = score"
          @mouseleave="hoverScore = 0"
          @click="previewScore = score"
        />
        <span class="mx-2 text-muted">{{ displayedScore }}/{{ maxScore }}</span>
      </div>
    </div>
    <b-icon class="bg-danger d-inline p-1 rounded-pill mx-2 h3 text-white my-2" icon="trash"
            @click="deleteQuestion()"/>
  </div>
</template>

<script>
export default {
  name: "StarInput",
  props: {
    item: {}
  },
  data() {
    return {
      previewScore: 0,
      hoverScore: 0,
    }
  },
  computed: {
    maxScore() {
      return 5
    },
    displayedScore() {
      return this.hoverScore || this.previewScore
    }
  },
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>
.star-icon {
  font-size: 1.75rem;
  cursor: pointer;
  color: #d1d5db;
  transition: color 0.15s ease;
}

.star-active {
  color: #f5b301;
}
</style>
